import { ToastContainer, toast } from "react-toastify";
import Logo from "../../beatai-logo.svg";
import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Navbar,
  Dropdown,
  Spinner,
  Badge,
  Image,
  Nav,
  Card,
} from "react-bootstrap";
import "./AccountSettings.css";
import "../chat/Chat.css";
import { useMediaQuery } from "react-responsive";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeftLong,
  faBars,
  faCheckCircle,
  faMagicWandSparkles,
  faPerson,
  faSave,
  faShieldAlt,
  faSignOutAlt,
  faUserEdit,
  faLock,
  faShieldHalved,
  faKey,
  faUserSecret,
  faTriangleExclamation,
  faArrowCircleLeft,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons";
import { useHistory } from "react-router-dom";
import Avatar, { useAvatar } from "./Avatar";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  changeAvatar,
  changePassword,
  requestEmailChange,
  updateProfile,
  validateEmailChange,
} from "../../service/api";
import { useUserProfile } from "../../service/hooks";
import "react-toastify/dist/ReactToastify.min.css";
import CookiePolicyFooter from "../chat/Cookies";

const AccountSettings = () => {

  const [modCookies, setModCookies] = useState(false);

  const showCookieSettings = () => setModCookies(true);
  const hideCookieSettings = () => setModCookies(false);

  const safetyTips = [
    {
      icon: faUserSecret,
      title: "Guard Personal Information",
      description:
        "Be cautious about sharing personal details online. Avoid posting sensitive information on public profiles.",
    },
    {
      icon: faLock,
      title: "Strong Password",
      description:
        "Use a combination of letters, numbers, and symbols. Make it at least 12 characters long and avoid personal information.",
    },
    // {
    //   icon: faShieldHalved,
    //   title: 'Enable Two-Factor Authentication',
    //   description: 'Add an extra layer of security by enabling 2FA. This ensures that even if someone has your password, they cannot access your account.'
    // },
    {
      icon: faKey,
      title: "Regular Password Updates",
      description:
        "Change your password every 3-6 months and never use the same password across multiple accounts.",
    },
  ];
  const { firstname, lastname, email, refreshProfile } = useUserProfile();

  const [formData, setFormData] = useState({
    firstName: firstname,
    lastName: lastname,
    currentEmail: email, // This would come from your auth context
    newEmail: "",
    currentPassword: "",
    newPassword: "",
    otp: "",
  });

  const [formErrors, setFormErrors] = useState({
    firstName: "",
    lastName: "",
    newEmail: "",
    newPassword: "",
    otp: "",
  });

  useEffect(() => {
    setFormData({
      firstName: firstname,
      lastName: lastname,
      currentEmail: email,
    });
  }, [firstname, lastname, email]);

  const [showEmailChange, setShowEmailChange] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [showPasswordChange, setShowPasswordChange] = useState(false);
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1224px)" });
  const history = useHistory();
  const [userLocation, setUserLocation] = useState("");
  const [show, setShow] = useState(false);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const successToast = (msg) =>
    toast(msg, {
      position: "top-right",
    });

  const [updatingProfile, setUpdatingProfile] = useState(false);
  const [sendingEmailOtp, setSendingEmailOtp] = useState(false);
  const [verifyingEmailOtp, setVerifyingEmailOtp] = useState(false);
  const [changingPassword, setChangingPassword] = useState(false);

  const handleEmailChange = () => {
    setShowEmailChange(true);
  };

  const handleSendOtp = () => {
    // Implementation for sending OTP
    setShowOtpInput(true);
  };

  const updateProfile_ = () => {
    setUpdatingProfile(true);
    updateProfile({
      first_name: formData.firstName,
      last_name: formData.lastName,
    })
      .then((e) => {
        refreshProfile();
        setUpdatingProfile(false);
        successToast("Profile data updated!");
        console.log(e, "errr");
      })
      .catch((e) => {
        if (e.message) {
            successToast(e.message);
        }
        setUpdatingProfile(false);
      });
  };

  const sendNewEmailCode_ = () => {
    setSendingEmailOtp(true);
    requestEmailChange(formData.newEmail)
      .then((e) => {
        refreshProfile();
        setShowOtpInput(true);
        setSendingEmailOtp(false);
        successToast(
          "Sent 6 digit code to provided email. It is valid for 10 minutes."
        );
        console.log(e, "errr");
      })
      .catch((e) => {
        successToast(e.message);
        setSendingEmailOtp(false);
      });
  };

  const validateEmailChangeOtp = () => {
    setVerifyingEmailOtp(true);
    validateEmailChange(formData.otp)
      .then(() => {
        setVerifyingEmailOtp(false);
        setShowOtpInput(false);
        refreshProfile()
        setShowEmailChange(false);
        successToast("Your email has been updated!");
      })
      .catch((e) => {
        if (e.message) {
            successToast(e.message)
        }
        setVerifyingEmailOtp(false);
      });
  };

  const changeUserPass = () => {
    setChangingPassword(true);
    changePassword({
        "old_password": formData.currentPassword,
        "new_password": formData.newPassword,
    }).then(() => {
        setChangingPassword(false);
        successToast("Password changed successfully");
        refreshProfile();
        setFormData({
            ...formData,
            newPassword: '',
            currentPassword: '',
        })
    }).catch((e) => {
        if (e.message) {
            successToast(e.message)
        }
        setChangingPassword(false);
    })
  }

  const SectionTitle = ({ title, hideHr }) => (
    <>
      <h5
        className="mb-2"
        style={{
          color: "#d9d9d9",
          opacity: 0.9,
          fontSize: "1.1em",
        }}
      >
        {title}
      </h5>
      {!hideHr && <hr className="mb-2" />}
    </>
  );

  const handleShow = () => setShow(true);
  const verified = localStorage.getItem("verified");

  const { setAvatarB64, getAvatarB64 } = useAvatar();
  const [avatarB64Local, setAvatarB64Local] = useState(null);
  const [changingAvatar, setChangingAvatar] = useState(false);
  const [lexLocalSources, setLexLocalSources] = useState(localStorage.getItem("pref:scan_local_source"));

  const handleFileChange = async (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }
    const file = event.target.files[0];

    // Validate file type (JPEG/PNG)
    if (!["image/jpeg", "image/png"].includes(file.type)) {
      alert("Only JPEG and PNG formats are allowed.");
      return;
    }

    try {
      setChangingAvatar(true);
      await changeAvatar(file);
      alert("Avatar updated successfully!");

      // Fetch and update the base64 image in the hook state
      const avatar = await getAvatarB64(true);
      setAvatarB64Local(avatar);
      setChangingAvatar(false);
    } catch (error) {
      alert(error.message);
      setChangingAvatar(false);
    }
  };
  useEffect(() => {
    setChangingAvatar(true);

    getAvatarB64()
      .then((avatar) => {
        setChangingAvatar(false);
        setAvatarB64Local(avatar);
      })
      .catch((e) => {
        setChangingAvatar(false);
      });
  }, []);

  const uploadAvatarRef = useRef(null);

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      style={{
        textDecoration: "none",
      }}
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </a>
  ));
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    history.push("/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R");
  };
  return (
    <div>
      <Navbar bg="dark" variant="dark" expand="sm" className="w-100 m-0 nav_">
        <Container fluid className="">
          <input
            hidden
            ref={uploadAvatarRef}
            type="file"
            accept="image/jpeg,image/png"
            onChange={handleFileChange}
          />
          <Button
            variant="outline-light"
            onClick={handleShow}
            className="border-0"
            disabled
          >
            <FontAwesomeIcon icon={faBars} />
          </Button>
          <Navbar.Brand
            className=""
            style={{ cursor: "pointer" }}
            title="+ Start new chat"
            onClick={(e) => history.push("/chat/")}
          >
            <Image src={Logo} style={{ maxWidth: "100px" }} />
          </Navbar.Brand>
          <Nav className="" style={{ width: "80%" }}>
            <Nav.Link
              as={Link}
              to="/chat/"
              className={
                window.location.href.indexOf("ai-image") > -1
                  ? "active nav-actv nav-link-style-cust nav-link_"
                  : "nav-link_ active"
              }
            >
              <FontAwesomeIcon
                style={{ color: "#d9d9d9", marginRight: "2px" }}
                icon={faArrowCircleLeft}
              />{" "}
              <span className="lex-color">
                <b> Lex</b>
              </span>
            </Nav.Link>
          </Nav>
          <Dropdown align="end" className="user-avatar-dropdown">
            <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
              <div className="user-avatar" style={{ textAlign: "center" }}>
                {!avatarB64Local &&
                  !changingAvatar &&
                  (firstname ? (
                    firstname[0]
                  ) : (
                    <FontAwesomeIcon icon={faPerson} />
                  ))}
                {!changingAvatar && avatarB64Local && (
                  <Avatar
                    base64Image={avatarB64Local}
                    width="30px"
                    height="30px"
                  />
                )}
                {changingAvatar && <Spinner size="sm" />}
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Container fluid>
                <Container className="text-center">
                  <div
                    className="user-avatar"
                    style={{ margin: "0 auto", width: "80px", height: "80px" }}
                    onClick={() => {
                      if (uploadAvatarRef.current) {
                        uploadAvatarRef.current.click();
                      }
                    }}
                  >
                    {!avatarB64Local &&
                      !changingAvatar &&
                      (firstname ? (
                        firstname[0]
                      ) : (
                        <FontAwesomeIcon icon={faPerson} />
                      ))}
                    {!changingAvatar && avatarB64Local && (
                      <Avatar
                        base64Image={avatarB64Local}
                        width="70px"
                        height="70px"
                      />
                    )}
                    {changingAvatar && <Spinner size="sm" />}
                  </div>
                  <br />
                  <p
                    style={{
                      fontSize: "0.7em",
                      color: "white",
                      margin: "0 auto",
                    }}
                  >
                    {firstname} {lastname}
                  </p>
                </Container>
              </Container>
              <Dropdown.Divider />
              <Dropdown.Item
                className="user-avt-dd-itm"
                onClick={() => {
                  if (uploadAvatarRef.current) {
                    uploadAvatarRef.current.click();
                  }
                }}
              >
                <FontAwesomeIcon icon={faUserEdit} className="me-2" /> Change
                Avatar
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
              >
                <Link
                  to="/membership"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faIdBadge} className="me-2" />{" "}
                  Membership
                </Link>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
              </Dropdown.Item>
              <Dropdown.Item
                className="user-avt-dd-itm"
              >
                <Link
                  to="/account-settings"
                  style={{
                    textDecoration: "none",
                    color: "white",
                  }}
                >
                  <FontAwesomeIcon icon={faShieldAlt} className="me-2" />{" "}
                  Account Settings
                </Link>
              </Dropdown.Item>
              <Dropdown.Item className="user-avt-dd-itm" onClick={handleLogout}>
                <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {verified === "false" ? (
            <i className="ms-auto">
              <Badge>Unverified</Badge>
            </i>
          ) : null}
        </Container>
      </Navbar>
      <Container className="py-4 account-settings-page d-flex flex-column align-items-center mt-4">
        <Container
          className=""
          style={{
            maxWidth: !isTabletOrMobile ? "50%" : "90%",
            height: "100%",
          }}
        >
          <span
            style={{
              color: "#d9d9d9",
              fontSize: "1e,",
            }}
          >
            <FontAwesomeIcon icon={faShieldAlt} className="me-2" />
            Account Settings
          </span>
          <div
            style={{
              marginBottom: "23px",
            }}
          ></div>
          {/* Full Name Section */}
          <div className="mb-3 acc-settings-form py-4 px-4">
            <SectionTitle title="Personal" />
            <Row>
              <Col sm={4} md={4} xs={12}>
                <Container
                  className="text-center"
                  style={{ paddingTop: "30px" }}
                >
                  <div
                    className="user-avatar"
                    style={{
                      margin: "0 auto",
                      width: "80px",
                      height: "80px",
                      marginTop: "20px",
                    }}
                    onClick={() => {
                      if (uploadAvatarRef.current) {
                        uploadAvatarRef.current.click();
                      }
                    }}
                  >
                    {!avatarB64Local &&
                      !changingAvatar &&
                      (firstname ? (
                        firstname[0]
                      ) : (
                        <FontAwesomeIcon icon={faPerson} />
                      ))}
                    {!changingAvatar && avatarB64Local && (
                      <Avatar
                        base64Image={avatarB64Local}
                        width="70px"
                        height="70px"
                      />
                    )}
                    {changingAvatar && <Spinner size="sm" />}
                  </div>
                  <br />
                  <p
                    style={{
                      color: "grey",
                      opacity: "0.9",
                      fontSize: "0.7em",
                    }}
                  >
                    Max 4MB, JPEGJPG & PNG Images
                  </p>
                </Container>
              </Col>
              <Col sm={8} md={8} xs={12}>
                <Form autoComplete="off">
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3" controlId="firstName">
                        <Form.Label
                          style={{
                            fontSize: "0.9em",
                          }}
                        >
                          First Name
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleInputChange}
                          placeholder="Enter first name"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group className="mb-3" controlId="lastName">
                        <Form.Label
                          style={{
                            fontSize: "0.9em",
                          }}
                        >
                          Last Name
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleInputChange}
                          placeholder="Enter last name"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button
                    size="sm"
                    variant="primary"
                    disabled={updatingProfile}
                    className="ac-pg-success-btn"
                    onClick={() => updateProfile_()}
                  >
                    {!updatingProfile && (
                      <>
                        <FontAwesomeIcon icon={faSave} /> Save Changes
                      </>
                    )}
                    {updatingProfile && (
                      <>
                        <Spinner size="sm" /> Saving
                      </>
                    )}
                  </Button>
                </Form>
              </Col>
            </Row>
          </div>

          {/* Email Section */}
          <div className="mb-3  acc-settings-form py-4 px-4">
            <SectionTitle title="Email" />
            <Form autoComplete="off">
              <Form.Group className="mb-3" controlId="currentEmail">
                <Form.Label
                  style={{
                    fontSize: "0.9em",
                  }}
                >
                  Current Email
                </Form.Label>
                <Form.Control
                  size="sm"
                  type="email"
                  value={formData.currentEmail}
                  disabled
                  style={{
                    cursor: "not-allowed",
                  }}
                />
              </Form.Group>

              {!showEmailChange ? (
                <Button
                  size="sm"
                  variant="primary"
                  onClick={handleEmailChange}
                  className="ac-pg-success-btn"
                >
                  Change Email
                </Button>
              ) : (
                <>
                  <Form.Group className="mb-3" controlId="newEmail">
                    <Form.Label
                      style={{
                        fontSize: "0.9em",
                      }}
                    >
                      New Email
                    </Form.Label>
                    <Form.Control
                      size="sm"
                      type="email"
                      name="newEmail"
                      value={formData.newEmail}
                      onChange={handleInputChange}
                      placeholder="Enter new email"
                    />
                  </Form.Group>

                  {!showOtpInput ? (
                    <Button
                      disabled={sendingEmailOtp}
                      size="sm"
                      variant="primary"
                      onClick={sendNewEmailCode_}
                      className="ac-pg-success-btn"
                    >
                      {sendingEmailOtp && (
                        <>
                          <Spinner size="sm" /> Sending
                        </>
                      )}
                      {!sendingEmailOtp && "Send OTP"}
                    </Button>
                  ) : (
                    <>
                      <Form.Group className="mb-3" controlId="otp">
                        <Form.Label
                          style={{
                            fontSize: "0.9em",
                          }}
                        >
                          Enter OTP
                        </Form.Label>
                        <Form.Control
                          size="sm"
                          type="text"
                          name="otp"
                          value={formData.otp}
                          onChange={handleInputChange}
                          placeholder="Enter OTP"
                        />
                      </Form.Group>
                      <Button
                        size="sm"
                        disabled={verifyingEmailOtp}
                        variant="success"
                        className="ac-pg-success-btn"
                        onClick={() => validateEmailChangeOtp()}
                      >
                        {!verifyingEmailOtp && "Verify & Save"}
                        {verifyingEmailOtp && <><Spinner size="sm"/> Verifying...</>}
                      </Button>
                    </>
                  )}
                </>
              )}
            </Form>
          </div>

          {/* Security Section */}
          <div className="mb-3  acc-settings-form py-4 px-4">
            <SectionTitle title="Security" />
            <Form autoComplete="off">
              {!showPasswordChange ? (
                <Button
                  size="sm"
                  variant="primary"
                  onClick={() => setShowPasswordChange(true)}
                  className="ac-pg-success-btn"
                >
                  Change Password
                </Button>
              ) : (
                <>
                  <Form.Group className="mb-3" controlId="currentPassword">
                    <Form.Label
                      style={{
                        fontSize: "0.9em",
                      }}
                    >
                      Current Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      name="currentPassword"
                      size="sm"
                      value={formData.currentPassword}
                      onChange={handleInputChange}
                      placeholder="Enter current password"
                    />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="newPassword">
                    <Form.Label
                      style={{
                        fontSize: "0.9em",
                      }}
                    >
                      New Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      name="newPassword"
                      size="sm"
                      value={formData.newPassword}
                      onChange={handleInputChange}
                      placeholder="Enter new password"
                    />
                  </Form.Group>

                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => changeUserPass()}
                    className="ac-pg-success-btn"
                  >
                    {
                        !changingPassword && <>
                        <FontAwesomeIcon icon={faSave} /> Save New Password
                        </>
                    }
                    {
                        changingPassword && <><Spinner size="sm" /> Processing...</>
                    }
                  </Button>
                </>
              )}
            </Form>
          </div>
          <div className="mb-3  acc-settings-form py-4 px-4">
            <SectionTitle title="Cookies" />
                  <Button
                    size="sm"
                    variant="success"
                    onClick={() => {
                      localStorage.removeItem("cookiePreferences")
                      successToast("Cookie settings cleared!")
                    }}
                    className="ac-pg-success-btn"
                  >
                    Clear Cookie Settings
                  </Button>
                  <br /><br />
                <span style={{
                  color: "grey"
                }}>* Please refresh the page to see the cookie consent after clearing preference.</span>
          </div>
          <div className="mb-3 acc-settings-form py-4 px-4">
          <h5 className="mb-2" style={{ color: '#d9d9d9', opacity: 0.9, fontSize: '1.1em' }}><span className="lex-color"><b>Lex</b></span> Configuration</h5>
          <hr class="mb-2"></hr>
            <Form.Group className="mb-3">
              <Form.Switch
                id="pref:scan_local_source"
                label="Search Local Sources for Answers"
                checked={lexLocalSources === "1"}
                onChange={(e) => {
                  if (e.target.checked) {
                    localStorage.setItem("pref:scan_local_source", "1");
                    successToast("Lex will search local sources first across chats.");
                    setLexLocalSources("1")
                  } else {
                    localStorage.removeItem("pref:scan_local_source");
                    successToast("Lex will not search for local sources.");
                    setLexLocalSources("")
                  }
                }}
                style={{
                  '--bs-form-switch-bg': '#e9ecef',
                  '--bs-form-switch-checked-bg': '#800080',
                  '--bs-form-switch-width': '3.5em',
                  '--bs-form-switch-height': '2em',
                }}
                className="custom-switch"
              />
            </Form.Group>
            <span style={{color: "grey"}}>Lex will look up BeatAI datasets if enabled. This will prioritize information if available through our local source to give answers.</span>
          </div>
          <CookiePolicyFooter hideIt={hideCookieSettings} hideFooter={true} overrideVisible={modCookies} />
        </Container>
        <hr
          style={{
            color: "white",
            backgroundColor: "white",
            border: "1px solid white",
            width: "50%",
          }}
        />
        <Container className="safety-tips-container mt-3 pb-4">
          <Row className="justify-content-center">
            <Col md={10}>
              <h6 className="text-white mb-4">
                <FontAwesomeIcon icon={faShieldHalved} className="me-2" />
                Account Safety Tips
              </h6>
              <Row>
                {safetyTips.map((tip, index) => (
                  <Col md={4} sm={6} className="mb-3" key={index}>
                    <Card className="h-100 bg-transparent border-0">
                      <Card.Body className="text-white">
                        <div
                          className="d-flex align-items-center mb-3"
                          style={{ minHeight: "90px" }}
                        >
                          <FontAwesomeIcon
                            icon={tip.icon}
                            className="fs-4 me-2"
                          />
                          <p className="mb-0" style={{ fontSize: "1.3em" }}>
                            <b>{tip.title}</b>
                          </p>
                        </div>
                        <Card.Text>{tip.description}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          <style>
            {`
          .safety-tips-container {
          opacity: 0.5;
            background-color: rgba(0, 0, 0, 0);
          }
          .card {
            transition: transform 0.2s;
            font-size: 0.7em !important;
            color: #d9d9d9 !important;
          }
          .card:hover {
            transform: translateY(-5px);
          }
        `}
          </style>
        </Container>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default AccountSettings;
